// Outbound webhook endpoint service — /v1/webhook-endpoints on the tickets API.
import { apiClient } from '../api-client';
import { WEBHOOKS } from '../../api-endpoints/api-endpoints';

export interface WebhookEndpointRow {
  id: string;
  url: string;
  events: string[];
  signingSecret: string;
  active: boolean;
  description: string | null;
  lastStatus: string | null;
  lastDeliveryAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export const webhooksService = {
  list: async (): Promise<WebhookEndpointRow[]> => {
    const res = await apiClient.get<{ data: WebhookEndpointRow[] }>(WEBHOOKS.list);
    return res?.data ?? [];
  },
  create: (input: { url: string; events: string[]; description?: string }): Promise<WebhookEndpointRow> =>
    apiClient.post<WebhookEndpointRow>(WEBHOOKS.create, input),
  update: (id: string, patch: Partial<Pick<WebhookEndpointRow, 'url' | 'events' | 'active' | 'description'>>): Promise<WebhookEndpointRow> =>
    apiClient.patch<WebhookEndpointRow>(WEBHOOKS.update(id), patch),
  remove: (id: string): Promise<void> => apiClient.delete<void>(WEBHOOKS.delete(id)),
  test: (id: string): Promise<{ enqueued: boolean }> => apiClient.post<{ enqueued: boolean }>(WEBHOOKS.test(id)),
  rotateSecret: (id: string): Promise<{ signingSecret: string }> =>
    apiClient.post<{ signingSecret: string }>(WEBHOOKS.rotateSecret(id)),
  signingSecret: (): Promise<{ signingSecret: string | null; endpointId: string | null }> =>
    apiClient.get<{ signingSecret: string | null; endpointId: string | null }>(WEBHOOKS.signingSecret),
};
